export const style = {
  body: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
    border: "0px solid #bbb",
    fontSize: "10pt",
    borderRadius: "20px",
    backgroundColor: "white",
  },
  selected: {
    boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
  },
  title: {
    position: "relative",
    padding: "8px 32px",
    textAlign: "center",
    flexGrow: 1,
    borderRadius: "20px 20px 0 0",
  },
  contentWrapper: {
    padding: "8px 0px",
  },
};
